import * as yup from 'yup';
import { useTranslations } from 'hooks/useTranslations';

interface IuseLicenceAuthorityFormSchema {
  isEdit: boolean;
  initFileIsDelete: boolean;
}

const useLicenceAuthorityFormSchema = ({
  isEdit,
  initFileIsDelete,
}: IuseLicenceAuthorityFormSchema) => {
  const { t } = useTranslations();
  const schema = yup.object({
    name: yup
      .string()
      .required(t('general.field.validation.required'))
      .max(255, t('general.field.validation.maxCharacters').replace('{0}', '255'))
      .trim(),
    isActive: yup.string().required(t('general.field.validation.required')),
    signatureAttachmentFile: yup
      .mixed()
      .nullable()
      .test('required', t('general.field.validation.required'), (value, params) => {
        if (isEdit && !initFileIsDelete) {
          return true;
        }
        return !!value;
      }),
    authorizedPersonName: yup
      .string()
      .required(t('general.field.validation.required'))
      .max(255, t('general.field.validation.maxCharacters').replace('{0}', '255'))
      .trim(),
    position: yup
      .string()
      .required(t('general.field.validation.required'))
      .max(255, t('general.field.validation.maxCharacters').replace('{0}', '255'))
      .trim(),
  });

  return { schema };
};

export default useLicenceAuthorityFormSchema;
